import { ActiveRecord } from '../../models/record';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ResetStore, SetActiveRecord } from './home.actions';

export type HomeStateModel = {
  activeRecord?: ActiveRecord;
};

export const initialState: HomeStateModel = {
  activeRecord: undefined,
};

@State<HomeStateModel>({
  name: 'home',
  defaults: initialState,
})
@Injectable()
export class HomeState {
  @Selector()
  static activeRecord(state: HomeStateModel) {
    return state.activeRecord;
  }

  @Action(SetActiveRecord)
  setActiveRecord(context: StateContext<HomeStateModel>, { record }: SetActiveRecord) {
    context.setState({
      activeRecord: record,
    });
  }

  @Action(ResetStore)
  resetStore(context: StateContext<HomeStateModel>) {
    context.setState(initialState);
  }
}
